import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

export default function ItemListScreen() {
  const [items, setItems] = useState([]); // Items to display
  const [query, setQuery] = useState(""); // Search query
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Fetch items when the screen loads or when query changes
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    axios
      .get(`https://foodgyde.com/api/fetch_items.php?${searchParams.toString()}`)
      .then((response) => setItems(response.data))
      .catch((err) => {
        console.error("Error fetching items:", err);
        setError("Unable to fetch items.");
      });
  }, [location.search]);

  // Handle search form submission
  const handleSearch = (e) => {
    e.preventDefault(); // Prevent page reload
    navigate(`/items?query=${query}`); // Update URL with new search query
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="w-full bg-blue-600 p-4 text-white text-center text-lg font-bold">
        Item List
      </header>

      {/* Search Bar */}
      <div className="p-4 bg-white shadow-md">
        <form onSubmit={handleSearch} className="flex items-center gap-4">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search for items..."
            className="flex-grow p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={handleSearch}
            className="px-4 py-2 bg-blue-600 text-white rounded-md shadow hover:bg-blue-700"
          >
            Search
          </button>
        </form>
      </div>

      {/* Item List */}
      <main className="p-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {error ? (
          <div className="col-span-full text-red-500">{error}</div>
        ) : items.length === 0 ? (
          <div className="col-span-full text-center text-gray-500">
            No items found for "{query}".
          </div>
        ) : (
          items.map((item) => {
            // Extract first image from imagePath (comma-separated string)
            const firstImage = item.imagePath ? item.imagePath.split(",")[0].trim() : null;

            return (
              <div
                key={item.id}
                onClick={() => navigate(`/item/${item.id}`)}
                className="bg-white p-4 rounded-md shadow hover:shadow-lg transition cursor-pointer flex items-center gap-4"
              >
                {/* Thumbnail Image (50x50) */}
                {firstImage && (
                  <img
                    src={firstImage}
                    alt={item.name}
                    className="w-[50px] h-[50px] object-cover rounded-md"
                  />
                )}

                {/* Item Info */}
                <div>
                  <h2 className="text-lg font-bold">{item.name}</h2>
                  <p className="text-gray-600 text-sm">{item.description}</p>
                  <p className="mt-1 text-blue-600 font-semibold">${item.price}</p>
                </div>
              </div>
            );
          })
        )}
      </main>
    </div>
  );
}
